import { useData } from '../DataContext';
import FeatureLabel from '../components/FeatureLabel';
import { Link } from 'react-router-dom';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";


gsap.registerPlugin(ScrollTrigger);

const Blogs = () => {
    const { blogs, isLoadingBlogs, error } = useData();
    const { t } = useTranslation();
   
    useEffect(() => {
        // Generic fade-in-up for all elements with .fade-in-up
        gsap.utils.toArray(".fade-in-up").forEach((el) => {
            gsap.fromTo(
                el,
                { y: 50, opacity: 0 },   // Start: slightly lower + invisible
                {
                    y: 0,
                    opacity: 1,
                    duration: 1,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: el,
                        start: "top 85%",   // When element enters viewport
                        toggleActions: "play none none reverse", // Animate in/out
                    },
                }
            );
        });
    }, []);

    if (isLoadingBlogs) return <p>{t('blogs.loading')}</p>;
    if (error) return <p>{error}</p>;

    return (
        <div>
            <div className="absolute inset-0 z-0 w-screen left-1/2 right-1/2 -mx-[50vw]">
                <img className='w-full' src={require("../media/images/StarSplash.png")} />
            </div>


            <div className='flex justify-center flex-col items-center mb-12 lg:min-h-[60vh]'>
                <h1 className='text-6xl text-[#101223] text-center mt-20 fade-in-up'>{t('blogs.heading')}</h1>
                <p className='text-[#101223] mt-12 font-semibold text-center max-w-screen-md fade-in-up'>{t('blogs.subheading')}</p>
            </div>

            <div className="relative">
                <div className="absolute inset-0 z-10 w-screen left-1/2 right-1/2 -mx-[50vw]">
                    <video
                        className="w-full h-[300px] sm:h-[400px] lg:h-[600px] object-cover"
                        src={require("../media/videos/video-call-and-computer-in-office.mov")}
                        autoPlay
                        muted
                        loop
                    />
                </div>
            </div>

            <div className="h-[150px] sm:h-[220px] lg:h-[420px]" />

            <div className="relative z-20 mt-64">
                <FeatureLabel text={t('blogs.label')} />

                <h2 className="text-7xl text-[#101223] mb-12">{t('blogs.allStoriesPrefix')} <span className='text-[#9B29FF]'>{t('blogs.allStoriesHighlight')}</span>{t('blogs.allStoriesSuffix')}</h2>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-24">
                    {blogs.map(blog => (
                        <div
                            key={blog.ID}
                            className="rounded-3xl overflow-hidden shadow-md bg-white hover:shadow-lg transition-shadow duration-300"
                        >
                            {/* Thumbnail */}
                            <img
                                src={`${process.env.REACT_APP_BLOGS_MEDIA_URL}/${blog.ThumbnailFileName || 'placeholder.png'}`}
                                alt={blog.Title}
                                className="w-full h-48 object-cover"
                            />

                            {/* Content */}
                            <div className="p-5 flex flex-col gap-3">
                                <h3 className="text-lg font-semibold text-gray-900">
                                    {blog.Title}
                                </h3>

                                <p className="text-sm text-gray-600 line-clamp-3">
                                    {blog.ShortDescription}
                                </p>

                                <Link
                                    to={`/blogs/${blog.ID}`}
                                    className="mt-2 text-sm font-medium text-[#9B29FF] hover:underline inline-flex items-center gap-1"
                                >
                                    {t('blogs.readBlog')} <span>→</span>
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>



        </div>
    );
};

export default Blogs;
